import React, { lazy, Suspense, useEffect } from "react";
import { UxLoading } from "@imaginelearning/mps-ux-component-library";
import useMppSubject from "../hooks/useMPPSubject";

// Using dynamic import without extension to let webpack handle resolution
const StudentHomePage = lazy(() => import("./StudentHomePage"));

function StudentHomeContainer() {
  const { updateMppSubject } = useMppSubject();

  useEffect(() => {
    const subject = sessionStorage.getItem("landingSubject");
    if (subject) {
      updateMppSubject(subject);
    }
  }, [updateMppSubject]);
  return (
    <Suspense fallback={<UxLoading />}>
      <StudentHomePage />
    </Suspense>
  );
}

export default StudentHomeContainer;
